import { Mail, Trash2, ShieldCheck } from "lucide-react";

const CONTACT_EMAIL = "hola@matronaia.com";
const SUBJECT = encodeURIComponent("Solicitud de eliminación de cuenta y datos");
const BODY = encodeURIComponent(
  "Hola,\n\nSoy usuaria de Matrona IA y solicito la eliminación de mi cuenta y de todos los datos personales asociados a ella.\n\nEl email asociado a mi cuenta es:\n\nGracias."
);

export default function DeleteAccount() {
  const mailto = `mailto:${CONTACT_EMAIL}?subject=${SUBJECT}&body=${BODY}`;

  return (
    <div data-testid="delete-account-page">
      <section className="max-w-3xl mx-auto px-6 sm:px-8 py-20 sm:py-28">
        <div className="text-center">
          <p className="eyebrow">Tus derechos</p>
          <h1 className="headline mt-4 text-4xl sm:text-5xl">
            Eliminar cuenta y datos
          </h1>
          <p className="mt-6 text-[#5c5450] leading-relaxed max-w-2xl mx-auto">
            En Matrona IA respetamos tu privacidad y tu derecho a controlar tus
            datos personales. Puedes solicitar la eliminación de tu cuenta y de
            los datos personales asociados en cualquier momento.
          </p>
        </div>

        <div className="mt-14 paper rounded-3xl border border-[#e8dcc8]/70 px-7 sm:px-12 py-12 shadow-[0_20px_60px_-30px_rgba(45,42,40,0.15)]">
          <div className="flex items-start gap-4 mb-8">
            <span
              className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
              style={{
                background:
                  "linear-gradient(135deg, #f4dee2 0%, #fdfaf6 100%)",
              }}
            >
              <Trash2 size={20} className="text-[#b7677a]" />
            </span>
            <div>
              <h2 className="font-serif text-2xl text-[#2d2a28]">
                Cómo solicitar la eliminación
              </h2>
              <p className="mt-3 text-[#5c5450] leading-relaxed">
                Puedes solicitar la eliminación de tu cuenta de dos formas:
              </p>
            </div>
          </div>

          <ul className="space-y-4 text-[#5c5450] leading-relaxed list-disc pl-6">
            <li>
              Desde la aplicación, si la opción “Eliminar cuenta” o “Borrar
              cuenta” está disponible en tu perfil o ajustes.
            </li>
            <li>
              Escribiendo un correo electrónico a{" "}
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                className="text-[#b7677a] underline underline-offset-4 decoration-[#f1c8d0]"
              >
                {CONTACT_EMAIL}
              </a>{" "}
              desde el email asociado a tu cuenta, indicando que deseas eliminar
              tu cuenta y tus datos personales.
            </li>
          </ul>

          <div className="mt-10">
            <h2 className="font-serif text-2xl text-[#2d2a28]">
              Qué datos se eliminarán
            </h2>
            <p className="mt-3 text-[#5c5450] leading-relaxed">
              Tras recibir la solicitud, Matrona IA eliminará o anonimizará los
              datos personales asociados a la cuenta, incluyendo, cuando
              corresponda:
            </p>

            <ul className="mt-4 space-y-3 text-[#5c5450] leading-relaxed list-disc pl-6">
              <li>Datos de cuenta.</li>
              <li>Información personal introducida por la usuaria.</li>
              <li>Conversaciones asociadas a la cuenta.</li>
              <li>Imágenes subidas voluntariamente por la usuaria.</li>
              <li>Preferencias o información vinculada al uso de la aplicación.</li>
            </ul>
          </div>

          <div className="mt-10">
            <h2 className="font-serif text-2xl text-[#2d2a28]">
              Datos que podrían conservarse temporalmente
            </h2>
            <p className="mt-3 text-[#5c5450] leading-relaxed">
              Algunos datos podrían conservarse durante el tiempo estrictamente
              necesario cuando exista una obligación legal, fiscal, contable, de
              seguridad, prevención de fraude o defensa frente a reclamaciones.
            </p>
            <p className="mt-3 text-[#5c5450] leading-relaxed">
              Las suscripciones y pagos gestionados por Apple App Store o Google
              Play deberán cancelarse desde la cuenta correspondiente de Apple o
              Google. La eliminación de la cuenta en Matrona IA no cancela
              automáticamente una suscripción activa gestionada por una tienda
              externa.
            </p>
          </div>

          <div className="mt-10">
            <h2 className="font-serif text-2xl text-[#2d2a28]">
              Plazo de eliminación
            </h2>
            <p className="mt-3 text-[#5c5450] leading-relaxed">
              Matrona IA tramitará las solicitudes de eliminación en un plazo
              máximo de 30 días desde la recepción de la solicitud, salvo que
              exista una obligación legal que exija conservar determinados datos
              durante más tiempo.
            </p>
            <p className="mt-3 text-[#5c5450] leading-relaxed">
              Las copias de seguridad técnicas podrán conservar algunos datos
              durante un periodo limitado por motivos de seguridad, tras el cual
              serán eliminados o sobrescritos.
            </p>
          </div>

          <div className="mt-10">
            <h2 className="font-serif text-2xl text-[#2d2a28]">
              Retirada del consentimiento
            </h2>
            <p className="mt-3 text-[#5c5450] leading-relaxed">
              La eliminación de la cuenta implica la retirada del consentimiento
              para el tratamiento de los datos asociados a esa cuenta, salvo
              aquellos tratamientos que deban mantenerse por obligación legal o
              por motivos legítimos de seguridad.
            </p>
          </div>

          <div className="mt-10 rounded-2xl bg-[#fdfaf6] border border-[#e8dcc8]/70 p-6">
            <div className="flex items-start gap-4">
              <ShieldCheck size={22} className="text-[#b7677a] flex-shrink-0 mt-1" />
              <p className="text-[#5c5450] leading-relaxed">
                Para cualquier duda sobre la eliminación de cuenta o el
                tratamiento de datos personales, puedes escribirnos a{" "}
                <a
                  href={`mailto:${CONTACT_EMAIL}`}
                  className="text-[#b7677a] underline underline-offset-4 decoration-[#f1c8d0]"
                >
                  {CONTACT_EMAIL}
                </a>
                .
              </p>
            </div>
          </div>

          <div className="mt-10 text-center">
            <a
              href={mailto}
              className="inline-flex items-center justify-center gap-2 rounded-full bg-[#b7677a] px-6 py-3 text-white font-medium shadow-sm hover:opacity-90 transition"
            >
              <Mail size={18} />
              Solicitar eliminación por email
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}